import { gql } from "@apollo/client";

export const DELETE_PERIOD = gql`
  mutation deleteBlockedPeriods(
    $ids: [ID!],
  ) {
    deleteBlockedPeriods(
      ids: $ids
    ) {
      id
    }
  }
`;

export const ADD_AVAILABILITY = gql`
  mutation addAvailability(
    $id: Int!,
    $day: Days!,
    $from: String!,
    $to: String!
  ) {
    addAvailability(
      professionist_id: $id,
      day: $day,
      time_from: $from,
      time_to: $to
  ) {
      id
    }
  }
`;
